module.exports = __webpack_public_path__ + "media/packs/src/assets/images/calendar-f94e8805a5d85f97245ad6284b2be213.svg";